import BlockType from 'src/enums/blockType';
import { toastError } from 'src/Toaster/Toast';
import { Block, Edge } from 'src/types/shared/blocksV3';

function getVacantSegment({
	blocks,
	parentBlock,
	selectedBlockEdge,
	defaultSize,
}: {
	blocks: Block[];
	parentBlock: Block;
	selectedBlockEdge: Edge;
	defaultSize: number;
}) {
	const deckboxes = blocks.filter((blk) => blk.type == BlockType.DECKBOX);
	const landings = deckboxes.flatMap((dk) => dk.landings);
	const stairs = deckboxes.flatMap((dk) => dk.stairs);
	const bumpouts = deckboxes.flatMap((dk) => dk.bumpouts);

	const allBlocks = [...deckboxes, ...landings, ...stairs, ...bumpouts];

	const vacantSegmentIndex = selectedBlockEdge.segments.findIndex((Segment) =>
		allBlocks.every((blk) => blk?.parentBlock.segmentId != Segment.id)
	);

	if (vacantSegmentIndex < 0) {
		toastError({
			title: 'No space left',
			description: `Edge ${selectedBlockEdge.label} on ${parentBlock.label} does not have space for a block of width ${defaultSize} inches`,
		});
		return;
	}

	const vacantSegment = selectedBlockEdge.segments[vacantSegmentIndex];

	if (vacantSegment.length < defaultSize) {
		toastError({
			title: 'Edge too short',
			description: `Segment ${vacantSegmentIndex + 1} (${vacantSegment.length} inches)  on Edge ${selectedBlockEdge.label} of ${parentBlock.label} cannot accomodate a block of width (${defaultSize} inches)`,
		});
		return;
	}

	return vacantSegment;
}

export function getVacantSegmentWithoutValidation({
	blocks,
	selectedBlockEdge,
}: {
	blocks: Block[];
	selectedBlockEdge: Edge;
}) {
	const deckboxes = blocks.filter((blk) => blk.type == BlockType.DECKBOX);
	const landings = deckboxes.flatMap((dk) => dk.landings);
	const stairs = deckboxes.flatMap((dk) => dk.stairs);
	const bumpouts = deckboxes.flatMap((dk) => dk.bumpouts);

	const allBlocks = [...deckboxes, ...landings, ...stairs, ...bumpouts];

	const vacantSegmentIndex = selectedBlockEdge.segments.findIndex((Segment) =>
		allBlocks.every((blk) => blk?.parentBlock.segmentId != Segment.id)
	);

	return vacantSegmentIndex > -1
		? selectedBlockEdge.segments[vacantSegmentIndex]
		: null;
}

export default getVacantSegment;
